import { FC, useEffect } from 'react';
import { isFuture, isPast } from 'date-fns';
import { useAuth } from '../contexts/auth.context.tsx';
import { useRefreshTokenMutation } from '../graphql/generated/operations/auth.ts';
import { jwtDecode } from 'jwt-decode';

export const TokenRefresher: FC = () => {
  const { accessToken, refreshToken, setTokens } = useAuth();
  const [refresh] = useRefreshTokenMutation();
  useEffect(() => {
    const checkAccessToken = async () => {
      if (!accessToken || !refreshToken) {
        return;
      }
      const decodedToken = jwtDecode(accessToken);
      const decodedRefreshToken = jwtDecode(refreshToken);
      if (decodedToken && decodedToken.exp && decodedRefreshToken && decodedRefreshToken.exp) {
        if (isPast(new Date(decodedToken.exp * 1000)) && isFuture(new Date(decodedRefreshToken.exp * 1000))) {
          // Invalidate the access token and refresh it
          const refreshTokens = await refresh({
            variables: {
              input: {
                refreshToken
              }
            }
          });
          if (refreshTokens.data?.refreshToken) {
            setTokens(refreshTokens.data.refreshToken.accessToken, refreshTokens.data.refreshToken.refreshToken);
          }
        } else if (isPast(new Date(decodedRefreshToken.exp * 1000)) && isPast(new Date(decodedToken.exp * 1000))) {
          // Expire the tokens
          setTokens();
        }
      }
    };
    checkAccessToken();
  }, [refreshToken]);
  return null;
};
